import React from "react";

const Header = () => {
  return (
    <header className="flex w-full h-16 items-center px-4 bg-background border-b">
      <a href="/" className="flex items-center">
        <img src="/assets/images/retreevo-logo.svg" alt="" className="h-8 w-auto" />
      </a>
    </header>
  );
};

Header.propTypes = {};

export default Header;
